import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconProcessosBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function PatioMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.GESTAO_PATIO, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 130,
      content: { menu: '9.1 - Cadastro de Balança', path: '/main/patio/cadastro-balanca' },
    },
    {
      id: 131,
      content: {
        menu: '9.2 - Movimentações - Balança',
        path: '/main/patio/movimentacoes-balanca',
      },
    },
    {
      id: 132,
      content: { menu: '9.3 - Cadastro de Tomadas', path: '/main/patio/cadastro-tomada' },
    },
    {
      id: 133,
      content: { menu: '9.4 - Utilização - Tomadas', path: '/main/patio/utilizacao-tomadas' },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconProcessosBlue} alt="Icon Tela de Gestão de Pátio" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>9. Gestão de Pátio</span>
      </PageMenu>{' '}
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(PatioMenu))
